import { render, staticRenderFns } from "./propertyForm.vue?vue&type=template&id=48f8bd32&"
import script from "./propertyForm.vue?vue&type=script&lang=js&"
export * from "./propertyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports